<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <h1 class="title-default">Painel do contador</h1>
        <p class="welcome-message">NFC-e, NF-e e NFS-e emitidas pelas empresas do grupo</p>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button type="button" class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
          @if (selection.hasValue()) {
            <span>Ações ({{ selection.selected.length }})</span>
          } @else {
            <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #acoesMenu="matMenu">
          <span
            [matTooltip]="'Selecione ao menos uma nota na listagem'"
            [matTooltipDisabled]="selection.hasValue()">
            <button mat-menu-item type="button" (click)="baixarNotasSelecionadas($event)" [disabled]="!selection.hasValue()">
              @if (isLoadingDownload) {
                <mat-spinner diameter="20" class="me-3"></mat-spinner>
              } @else {
                <mat-icon class="material-symbols-outlined">download</mat-icon>
              }
              <span>Baixar notas selecionadas</span>
            </button>
          </span>
          <button mat-menu-item type="button" (click)="fazerPedidoExtracao(tipoExtracaoEnum.NotaXml)">
            <mat-icon class="material-symbols-outlined">collections_bookmark</mat-icon>
            <span>Baixar XML de todas as notas do filtro</span>
          </button>
          <button mat-menu-item type="button" (click)="fazerPedidoExtracao(tipoExtracaoEnum.NotaCsv)">
            <mat-icon class="material-symbols-outlined">description</mat-icon>
            <span>Baixar CSV da tabela</span>
          </button>
          <button mat-menu-item type="button" (click)="fazerPedidoExtracao(tipoExtracaoEnum.RelatorioProdutoNFeNFCe)">
            <mat-icon class="material-symbols-outlined">list_alt</mat-icon>
            <span>Baixar lista de produtos</span>
          </button>
          <button mat-menu-item type="button" (click)="abrirRelatorioCfop()">
            <mat-icon class="material-symbols-outlined">summarize</mat-icon>
            <span>Relatório de CFOP</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <form [formGroup]="filterForm" (ngSubmit)="aplicarFiltros()">
      <div class="row search-area">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input
              matInput
              type="text"
              formControlName="pesquisar"
              placeholder="Pesquisar nº da nota, emitente, destinatário ou CPF/CNPJ" />
            <button
              mat-icon-button
              matSuffix
              type="submit"
              class="icon-mat-symbols-btn"
              aria-label="Pesquisar">
              <mat-icon class="material-symbols-outlined">search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 filter-container">
          <button
            #periodoMenuTrigger="matMenuTrigger"
            mat-stroked-button
            type="button"
            class="btn-periodo"
            [matMenuTriggerFor]="periodoMenu"
            [class.btn-periodo--ativo]="periodoSelecionado !== periodoEnum.DoMes">
            {{ periodoLabel }}
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          </button>
          <mat-menu #periodoMenu="matMenu" class="periodo-custom-menu">
            <div class="periodo-menu-content">
              @for (opcao of opcoesPeriodo; track opcao.periodo) {
                <button
                  type="button"
                  class="periodo-menu-item"
                  [class.periodo-item-selecionado]="periodoSelecionado === opcao.periodo"
                  (click)="selecionarPeriodo(opcao.periodo, $event)">
                  <span>{{ opcao.rotulo }}</span>
                  @if (periodoSelecionado === opcao.periodo) {
                    <mat-icon>check</mat-icon>
                  }
                </button>
              }

              @if (periodoSelecionado === periodoEnum.DoIntervalo) {
                <div class="periodo-intervalo-fields" (click)="$event.stopPropagation()">
                  <mat-form-field appearance="outline">
                    <mat-label>De</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pickerDe"
                      placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataDe')"
                      formControlName="dataDe" />
                    <mat-datepicker-toggle matSuffix [for]="pickerDe"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDe></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Até</mat-label>
                    <input
                      matInput
                      [matDatepicker]="pickerAte"
                      placeholder="DD/MM/AAAA"
                      (input)="onDateInput($event, 'dataAte')"
                      formControlName="dataAte" />
                    <mat-datepicker-toggle matSuffix [for]="pickerAte"></mat-datepicker-toggle>
                    <mat-datepicker #pickerAte></mat-datepicker>
                    @if (filterForm.get('dataAte')?.hasError('dataInvalida')) {
                      <mat-error>Data final menor que a inicial</mat-error>
                    }
                    @if (filterForm.get('dataAte')?.hasError('intervaloExcedido')) {
                      <mat-error>Intervalo máx. de {{ limiteMeses }} meses</mat-error>
                    }
                  </mat-form-field>
                  <div class="periodo-intervalo-actions">
                    <button
                      type="button"
                      mat-button
                      class="btn-secondary"
                      (click)="cancelarIntervalo(periodoMenuTrigger)">
                      Cancelar
                    </button>
                    <button
                      type="button"
                      mat-flat-button
                      class="btn-primary"
                      (click)="aplicarIntervalo(periodoMenuTrigger)">
                      Aplicar
                    </button>
                  </div>
                </div>
              }
            </div>
          </mat-menu>

          <button
            mat-stroked-button
            type="button"
            class="btn-filter"
            [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados"
            [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="filterForm">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros</h6>
                <div class="filter-menu__form">
                  <app-select-pesquisavel
                    label="Modelo do documento"
                    [control]="$any(filterForm.get('tiposNota'))"
                    [idField]="'idModeloDocumento'"
                    [nameField]="'nome'"
                    [subtitleFields]="['descricao']"
                    [offlineList]="listaModeloDocumento"
                    [multiple]="true"
                    [isOptional]="true"
                    hint="Selecione os modelos">
                  </app-select-pesquisavel>

                  <app-select-pesquisavel
                    label="Emitente"
                    [control]="$any(filterForm.get('listCnpj'))"
                    [idField]="'cnpj'"
                    [nameField]="'nomeEmpresa'"
                    [subtitleFields]="['cnpj']"
                    [offlineList]="listaEmpresas"
                    [multiple]="true"
                    [isOptional]="true"
                    [hint]="
                      isSingleCompanyView
                        ? 'Filtro travado: o grupo tem uma única empresa'
                        : 'Sem seleção, considera todas as empresas do grupo'
                    ">
                  </app-select-pesquisavel>

                  <app-select-pesquisavel
                    label="Status"
                    [control]="$any(filterForm.get('isCacnelada'))"
                    [idField]="'id'"
                    [nameField]="'nome'"
                    [offlineList]="listaStatus"
                    [isOptional]="true"
                    emptyOptionLabel="Todas">
                  </app-select-pesquisavel>

                  <mat-form-field appearance="outline">
                    <mat-label>Série</mat-label>
                    <input matInput type="text" formControlName="serie" mask="000" [validation]="false" inputmode="numeric" maxlength="3" />
                  </mat-form-field>

                  <mat-form-field appearance="outline">
                    <mat-label>CFOP</mat-label>
                    <input matInput type="text" formControlName="cfop" [mask]="masks.cfop" [validation]="false" inputmode="numeric" />
                    <button mat-icon-button matSuffix type="button" class="icon-mat-symbols-btn"
                        aria-label="Pesquisar CFOP" [disabled]="filterForm.get('cfop')?.disabled"
                        (click)="$event.stopPropagation(); pesquisarCfop()">
                        <mat-icon>search</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button type="button" class="btn-secondary" matMenuClose>Cancelar</button>
                <button
                  mat-flat-button
                  type="button"
                  class="btn-primary"
                  (click)="aplicarFiltros()"
                  matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    @if (dataSource.data.length > 0) {
      <div class="table-container desktop-view">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="w-checkbox">
              <mat-checkbox
                (change)="toggleAllRows()"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" class="w-checkbox">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="selection.toggle(row)"
                [checked]="selection.isSelected(row)"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="tipoNota">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Modelo</th>
            <td mat-cell *matCellDef="let row">{{ row.modeloDocumento }}</td>
          </ng-container>

          <ng-container matColumnDef="nota">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nota / Série</th>
            <td mat-cell *matCellDef="let row">{{ row.numero }}{{ row.serie ? ' / ' + row.serie : '' }}</td>
          </ng-container>

          <ng-container matColumnDef="emissao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Emissão</th>
            <td mat-cell *matCellDef="let row">{{ row.dataEmissao | date: 'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="cfop">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>CFOP</th>
            <td mat-cell *matCellDef="let row">{{ (row.cfop || '') | mask: '0.000' : { patterns: cfopMaskPatterns } }}</td>
          </ng-container>

          <ng-container matColumnDef="emitente">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Emitente</th>
            <td mat-cell *matCellDef="let row" [matTooltip]="row.cnpjEmitente + ' | ' + (row.nomeEmitente || '')">
              <span class="truncate-cell">{{ row.cnpjEmitente }} | {{ row.nomeEmitente }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="destinatario">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Destinatário</th>
            <td mat-cell *matCellDef="let row" [matTooltip]="(row.cnpjDestinatario || '') + ' | ' + (row.nomeDestinatario || '')">
              <span class="truncate-cell">{{ row.cnpjDestinatario }} | {{ row.nomeDestinatario }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Valor (R$)</th>
            <td mat-cell *matCellDef="let row" class="text-end nota-valor-cell">{{ row.valor || 0 | abnt: 'preco' }}</td>
          </ng-container>

          <ng-container matColumnDef="acoes">
            <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
            <td mat-cell *matCellDef="let row" class="text-center w-actions">
              <button
                mat-icon-button
                type="button"
                class="icon-mat-symbols-btn btn-spinner"
                [class.btn-loading]="row.isLoading || row.isLoadingDanfe"
                [matMenuTriggerFor]="menu"
                [disabled]="row.isLoading || row.isLoadingDanfe"
                [attr.aria-label]="row.isLoading || row.isLoadingDanfe ? 'Executando ação da nota' : 'Ações da nota'">
                <span class="material-symbols-outlined">more_horiz</span>
                @if (row.isLoading || row.isLoadingDanfe) { <mat-spinner diameter="20"></mat-spinner> }
              </button>
              <mat-menu #menu="matMenu">
                <span
                  [matTooltip]="'A DANFE não pode ser gerada para NFC-e ou NFS-e'"
                  [matTooltipDisabled]="row.idModeloDocumento === modeloDocumentoEnum.NFe">
                  <button
                    mat-menu-item
                    type="button"
                    [disabled]="row.idModeloDocumento !== modeloDocumentoEnum.NFe"
                    (click)="visualizarDanfe(row)">
                    <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                    <span>Visualizar DANFE</span>
                  </button>
                </span>
                <button mat-menu-item type="button" (click)="baixarXml(row)">
                  <mat-icon class="material-symbols-outlined">download</mat-icon>
                  <span>Baixar XML</span>
                </button>
                <button mat-menu-item type="button" (click)="verDetalhes(row)">
                  <mat-icon class="material-symbols-outlined">chevron_right</mat-icon>
                  <span>Detalhes da nota</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <div class="mobile-view">
        @for (row of dataSource.data; track row.origemDocumentoFiscalEmitido + '-' + row.idDocumentoFiscalEmitido) {
          <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(row)">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-2">
                <mat-checkbox
                  (change)="selection.toggle(row)"
                  [checked]="selection.isSelected(row)"
                  color="primary"></mat-checkbox>
                <div class="d-flex flex-column">
                  <span class="text-bold">{{ row.modeloDocumento }} {{ row.numero }}{{ row.serie ? ' / ' + row.serie : '' }}</span>
                  <small>{{ row.dataEmissao | date: 'dd/MM/yyyy' }}</small>
                </div>
              </div>
              <button
                mat-icon-button
                type="button"
                class="icon-mat-symbols-btn btn-spinner"
                [class.btn-loading]="row.isLoading || row.isLoadingDanfe"
                [matMenuTriggerFor]="menuMobile"
                [disabled]="row.isLoading || row.isLoadingDanfe"
                [attr.aria-label]="row.isLoading || row.isLoadingDanfe ? 'Executando ação da nota' : 'Ações da nota'">
                <span class="material-symbols-outlined">more_horiz</span>
                @if (row.isLoading || row.isLoadingDanfe) { <mat-spinner diameter="20"></mat-spinner> }
              </button>
              <mat-menu #menuMobile="matMenu">
                <span
                  [matTooltip]="'A DANFE não pode ser gerada para NFC-e ou NFS-e'"
                  [matTooltipDisabled]="row.idModeloDocumento === modeloDocumentoEnum.NFe">
                  <button
                    mat-menu-item
                    type="button"
                    [disabled]="row.idModeloDocumento !== modeloDocumentoEnum.NFe"
                    (click)="visualizarDanfe(row)">
                    <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                    <span>Visualizar DANFE</span>
                  </button>
                </span>
                <button mat-menu-item type="button" (click)="baixarXml(row)">
                  <mat-icon class="material-symbols-outlined">download</mat-icon>
                  <span>Baixar XML</span>
                </button>
                <button mat-menu-item type="button" (click)="verDetalhes(row)">
                  <mat-icon class="material-symbols-outlined">chevron_right</mat-icon>
                  <span>Detalhes da nota</span>
                </button>
              </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
              <div class="row">
                <div class="col-12 mb-2">
                  <small class="d-block">Emitente</small>
                  <span class="truncate-cell">{{ row.cnpjEmitente }} | {{ row.nomeEmitente }}</span>
                </div>
                <div class="col-12 mb-2">
                  <small class="d-block">Destinatário</small>
                  <span class="truncate-cell">{{ row.cnpjDestinatario }} | {{ row.nomeDestinatario }}</span>
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">CFOP</small>
                  <span>{{ (row.cfop || '') | mask: '0.000' : { patterns: cfopMaskPatterns } }}</span>
                </div>
                <div class="col-6 mb-2">
                  <small class="d-block">Valor (R$)</small>
                  <span class="text-bold">{{ row.valor || 0 | abnt: 'preco' : 2 }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <div
        class="text-center load-more"
        [matTooltip]="ultimaPagina ? 'Todas as notas foram carregadas' : isLoading ? 'Carregando notas' : ''">
        <button mat-button type="button" (click)="proximaPagina()" [disabled]="isLoading || ultimaPagina">
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            <span class="material-symbols-outlined">keyboard_arrow_down</span>
            Ver mais
          }
        </button>
      </div>
    } @else if (isLoading || isLoadingInitialData) {
      <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
      <app-empty-list
        title="Nenhuma nota encontrada"
        subTitle="Tente alterar o período ou os filtros de busca"></app-empty-list>
    }
  </div>
</div>

<!-- Rodapé de totalização: padrão global .footer-totals. -->
<div class="footer-totals">
  <div class="footer-totals-inner">
    <div class="footer-totals-item footer-totals-item--total">
      <span class="footer-totals-label">Valor total (R$)</span>
      <span class="footer-totals-value">{{ valorTotal || 0 | abnt: 'preco' : 2 }}</span>
    </div>
    <div class="footer-totals-count">
      <mat-icon class="material-symbols-outlined">description</mat-icon>
      <span>{{ dataSource.data.length }} de {{ fullListSize }} notas</span>
    </div>
  </div>
</div>
<div class="footer-totals-height-fake"></div>

<button
  class="btn-footer-totals-mobile"
  type="button"
  (click)="toggleGavetaMobile()"
  aria-label="Abrir resumo das notas">
  <span class="material-symbols-outlined">analytics</span>
</button>

@if (isMobileDrawerOpen) {
  <div class="footer-totals-mobile-sheet-backdrop" (click)="fecharGavetaMobile()"></div>
}
<div class="footer-totals-mobile-sheet" [class.open]="isMobileDrawerOpen">
  <div class="footer-totals-mobile-sheet__header modal-header">
    <div class="modal-header-icon">
      <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
    </div>
    <div class="modal-header-titles">
      <h3 class="modal-title">Resumo das notas</h3>
    </div>
    <div class="modal-header-close-btn-container">
      <button
        mat-icon-button
        type="button"
        class="modal-close-btn icon-mat-symbols-btn"
        (click)="fecharGavetaMobile()"
        aria-label="Fechar resumo das notas">
        <mat-icon class="material-symbols-outlined">close</mat-icon>
      </button>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__content">
    <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--total footer-totals-mobile-sheet__item--full">
      <span class="footer-totals-mobile-sheet__label">VALOR TOTAL (R$)</span>
      <span class="footer-totals-mobile-sheet__value">{{ valorTotal || 0 | abnt: 'preco' : 2 }}</span>
    </div>
  </div>
  <div class="footer-totals-mobile-sheet__footer">
    <span class="footer-totals-count">
      <mat-icon class="material-symbols-outlined">description</mat-icon>
      {{ dataSource.data.length }} de {{ fullListSize }} notas
    </span>
  </div>
</div>
